export function useFile() {
  return {
    remoteToFile: async (url, name) => {
      const response = await fetch(url);
      const blob = await response.blob();
      const file = new File([blob], name, {type: blob.type});

      file.objectURL = window.URL.createObjectURL(file);

      return file;
    },

    downloadFile: async (file, name, isArchive) => {
      let applicationType;
      let extensionFile;

      if (isArchive) {
        applicationType = 'application/zip';
        extensionFile = '.zip';
      } else {
        applicationType = 'video/mp4';
        extensionFile = '';
      }

      const link = document.createElement("a");

      if (typeof file === 'string') {
        link.href = file;
      } else {
        const blob = new Blob([file], {type: applicationType});
        link.href = URL.createObjectURL(blob);
      }

      link.target = '_blank';
      link.download = name + extensionFile;

      link.click();
      URL.revokeObjectURL(link.href);
      link.remove();
    },

  }
}
